// extracted by mini-css-extract-plugin
export default {"NEUTRAL_500":"#424242","logo-toggle":"logo-toggle-f5a","toggle":"toggle-c96","logo-link":"logo-link-ac9"};